import axios from 'axios';
import { apiUrl } from './index';

export interface LabelsQueryParams {
  page?: number
  per_page?: number
  sort?: string
  order?: string
  search?: string
  countries?: string[]
}

/** Create/update request body — `color`/`country` are sent as codes, unlike the `Label` response shape. */
export interface LabelPayload {
  id?: number
  name?: string
  color?: number
  country?: string
}

export default {
  getItems(params: LabelsQueryParams) {
    return axios({
      method: 'get',
      url: `${apiUrl}/labels`,
      params,
    });
  },
  createItem(label: LabelPayload) {
    return axios({
      method: 'post',
      url: `${apiUrl}/labels`,
      data: {
        ...label,
      },
    });
  },
  updateItem(label: LabelPayload) {
    return axios({
      method: 'put',
      url: `${apiUrl}/labels/${label.id}`,
      data: {
        ...label,
      },
    });
  },
  getItem({ id }: { id: number }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/labels/${id}`,
    });
  },
  removeItem({ id }: { id: number }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/labels/${id}`,
    });
  },
};
